import { Link } from '@material-ui/core'
import React from 'react'

import { ItemWarning } from './ItemWarning'

export interface ItemWarningMessagesProps {
  messageCode: string | null | undefined
  state: string | null | undefined
}

const ItemWarningMessages: React.FC<ItemWarningMessagesProps> = ({ messageCode, state }) => {
  const isCA = state && state === 'CA'

  if (!isCA || !messageCode) {
    return null
  }

  return (
    <>
      {messageCode === 'Prop-65' && (
        <ItemWarning>
          <strong>WARNING:</strong> Reproductive Harm -{' '}
          <Link href="https://www.p65warnings.ca.gov/products/food" rel="noopener" target="_blank">
            www.p65Warnings.ca.gov/food
          </Link>
          .
        </ItemWarning>
      )}
      {messageCode === 'P65-CJ' && (
        <ItemWarning>
          <strong>WARNING:</strong> This product contains a substance known to the State of
          California to cause birth defects or other reproductive harm.
        </ItemWarning>
      )}
      {messageCode === 'P65-PG' && (
        <ItemWarning>
          <strong>WARNING:</strong> This product can expose you to progesterone, a chemical known to
          the State of California to cause cancer. For more information go to{' '}
          <Link href="https://www.p65warnings.ca.gov/" rel="noopener" target="_blank">
            www.p65warnings.ca.gov
          </Link>
          .
        </ItemWarning>
      )}
    </>
  )
}

export default ItemWarningMessages
